if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /**
         * Google Tagmanager
         * data-gtm-event = "['click', 'mouseover']"
         * expects:
         * <someelement data-interaction="GtmTouchpoint" data-gtm-datalayer='[{"page" : {"formType": "#page.formXXType#","formName": "#page.formName#"},"events": {"category": "#events.category#","action": "#events.action#","label": "#events.label#"},"event":"iteraction.form.changeButton"}]'>
         * some wher in the html an array called: dataLayer[]
         */
        ZZ.GtmTouchpoint = function(GtmTouchpointContainer) {
            var base = this;
            base.container = GtmTouchpointContainer;
            base.datalayerData = jQuery.parseJSON(
                base.container.attr("data-gtm-datalayer")
            );
            base._eventsToBind = base.container.attr("data-gtm-event");

            base.assignListeners();
        };

        ZZ.GtmTouchpoint.prototype = {
            assignListeners: function() {
                var base = this;

                if (
                    base._eventsToBind !== "" &&
                    base._eventsToBind !== undefined
                ) {
                    base._eventsToBind = base._eventsToBind.replace(
                        /[`~!@#$%^&*()_|+\-=?;:'" .<>\{\}\[\]\\\/]/gi,
                        ""
                    );
                    base._eventsToBind = base._eventsToBind.split(",");

                    for (
                        var i = 0, len = base._eventsToBind.length;
                        i < len;
                        i++
                    ) {
                        base.container.on(
                            base._eventsToBind[i],
                            base.pushData.bind(base)
                        );
                    }
                } else {
                    base.container.on("click", base.pushData.bind(this));
                }
            },

            appendTodatalayerData: function(property, data) {
                if (base.datalayerData !== null) {
                    base.datalayerData[property] = data;
                }
            },

            pushData: function(e) {
                if (window["dataLayer"]) {
                    window["dataLayer"].push(this.datalayerData);
                }
            }
        };
    })(jQuery);
} else {
    (function() {
        "use strict";

        /**
         * google tagmanager, implemented with VanillaJS
         *
         */
        ZZ.GtmTouchpoint = function(GtmTouchpointContainer) {
            var base = this;
            base.container = GtmTouchpointContainer;
            base.datalayerData = JSON.parse(
                base.container.getAttribute("data-gtm-datalayer")
            );
            base._eventsToBind = base.container.getAttribute("data-gtm-event");

            base.assignListeners();
        };

        ZZ.GtmTouchpoint.prototype = {
            assignListeners: function() {
                var base = this;

                if (
                    base._eventsToBind !== undefined &&
                    base._eventsToBind !== null &&
                    base._eventsToBind !== ""
                ) {
                    base._eventsToBind = base._eventsToBind.replace(
                        /[`~!@#$%^&*()_|+\-=?;:'" .<>\{\}\[\]\\\/]/gi,
                        ""
                    );
                    base._eventsToBind = base._eventsToBind.split(",");

                    for (
                        var i = 0, len = base._eventsToBind.length;
                        i < len;
                        i++
                    ) {
                        base.container.addEventListener(
                            base._eventsToBind[i],
                            base.pushData.bind(base)
                        );
                    }
                } else {
                    base.container.addEventListener(
                        "click",
                        base.pushData.bind(this)
                    );
                }
            },

            appendTodatalayerData: function(property, data) {
                if (base.datalayerData !== null) {
                    base.datalayerData[property] = data;
                }
            },

            pushData: function(e) {
                if (window["dataLayer"]) {
                    window["dataLayer"].push(this.datalayerData);
                }
            }
        };
    })();
}
